<div class="page-header">
  <app-back-button class="page-header-start" (clicked)="clickedBack.next($event)" [preventDefault]="preventBack" [useBrowserBack]="useBrowserBack" *ngIf="showBack"></app-back-button>
  <span class="page-title">{{title}}</span>
  <span class="page-header-end" *ngIf="showBack">
    <ng-content></ng-content>
  </span>
</div>
